import { t } from '@lingui/macro';
import { NoddiButtonProps, NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useBookingActions } from '../../pages/BookingFlow/bookingStore';

type NewBookingButtonProps = {
  className?: string;
  defaultSize?: boolean;
  loading?: boolean;
  variant?: NoddiButtonProps['variant'];
};
const NewBookingButton = ({ className, loading, defaultSize, variant }: NewBookingButtonProps) => {
  const { clearStore } = useBookingActions();

  return (
    <NoddiLink
      className={className}
      variant={variant}
      size={defaultSize ? 'default' : 'small'}
      endIcon='ArrowRight'
      onClick={clearStore}
      to={customerRoutes.newBookingAddress.getPath()}
      loading={loading}
    >{t`New booking`}</NoddiLink>
  );
};

// eslint-disable-next-line import/no-default-export
export default NewBookingButton;
